import { render, staticRenderFns } from "./WindCompass.vue?vue&type=template&id=2402deb9&lang=html&"
import script from "./WindCompass.vue?vue&type=script&lang=js&"
export * from "./WindCompass.vue?vue&type=script&lang=js&"
import style0 from "./WindCompass.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports